import { AssetReference } from "@kosmod/assets";
import { ID, idDef } from "@kosmod/kit"
import { s } from "@kosmod/pancake";
import { K3D } from "@kosmod/graphics-3d";

import * as three from 'three';
import { GameID } from "@kosmod/sesame";
import { TerrainCanvasID } from "./scene";
import { Box2 } from "../../graphics_3d/defs/shapes";

export type TerrainBrushID = ID<"terrain-brush">;
export const TerrainBrushID = s.ref<TerrainBrushID>()(idDef);

export type TerrainBrush = {
  game: GameID,
  id: TerrainBrushID,

  name: string,

  // iconAsset: AssetReference,
  modelAsset: AssetReference,

  renderMode: string,

  /**
   * A brush is composed of multiple parts.
   * Each part is references by a "path" down the
   * GLTF asset's scene tree comprised of the objects
   * names.
   */
  partNames: {
    diorama: null | string[],
    wall_1: null | string[],
    floor_4: null | string[],
  }
  /**
   * Brushes that paint on the same layer
   * will overwrite one another. Setting "Layer"
   * to null will always grant this brush a unique layer
   * for each surface.
   */
  // layer: null | string,
}
export const TerrainBrush = s.ref<TerrainBrush>()(s.o({
  game: GameID,
  id: TerrainBrushID,

  name: s.str,

  // iconAsset: AssetReference,
  modelAsset: AssetReference,

  renderMode: s.str,

  // TODO:
  // walkable: s.bool,

  partNames: s.o({
    wall_1: s.optional(s.a(s.str)),
    diorama: s.optional(s.a(s.str)),
    floor_4: s.optional(s.a(s.str)),
  }),
}));


// export type TerrainBrushPart = {
//   objectPath: string[],
// }

// export const BRUSH_FUNCS = {

// }

/**
 * Created at runtime
 */
// export type TerrainBrushNode = 
//   | {
//       type: 'mesh',
//       geometry: three.BufferGeometry,
//       material: three.Material,
//       transform: K3D.FullTransform,
//       children: number[],
//     }
//   | {
//     type: 'group',
//     transform: K3D.FullTransform,
//     children: number[],
//   }
  